export const environment = {
  production: false,
  appVersion: 'v8.0.29',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  appThemeName: 'Risk Release',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',

  sentry: {
    enabled: false,
    dsn: '',
  },

  appHTMLIntegration:
    'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl: 'https://preview.keenthemes.com/metronic8/angular/docs/changelog',

  testingAuthCredencial: {
    email: 'testing@techroversolutions.com',
    password: 'Techrover@123',
  },

  appDemos: {
    demo1: {
      title: 'Demo 1',
      description: 'Default Dashboard',
      published: true,
      thumbnail: './assets/media/demos/demo1.png',
    },
  },

  googleMaps: {
    apiKey: 'AIzaSyA-dNqA43JwBhy6szXybyPM7jXSPyAXm9s',
  },
};
